import { PAGINATION_DEFAULT_VALUE } from '../../helpers/defaultValue';
import { OrdersActionTypes } from './constants';

const INIT_STATE = {
    loading: false,
    error: null,
    orders: null,
    creatingLabel: false,
    cancellingOrder: false,
    createdOrder: null,
    pagination: PAGINATION_DEFAULT_VALUE,
    loadingOrdersReport: false,
    ordersReport: null,
    errorOrdersReport: null,
};

type OrdersAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string, creatingLabel: Boolean, createdOrder: any },
};
//TODO: define data type for orders
type State = { loading: Boolean, error?: null, orders: any };

const Orders = (state: State = INIT_STATE, action: OrdersAction): any => {
    //console.log(action);
    switch (action.type) {
        case OrdersActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case OrdersActionTypes.GET_ALL_ORDERS: {
                    return {
                        ...state,
                        loading: false,
                        orders: action.payload.data.orders,
                        pagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                    };
                }
                case OrdersActionTypes.CREATE_LABEL_FOR_ORDER: {
                    return { ...state, creatingLabel: false, createdOrder: action.payload.data };
                }
                case OrdersActionTypes.REQUEST_ORDER_REFUND: {
                    const orderId = action.payload.data.orderId;
                    return {
                        ...state,
                        cancellingOrder: false,
                        orders: (state.orders || []).map((order) =>
                            order.id === orderId
                                ? { ...order, orderStatus: 'canceled', orderPaymentStatus: 'voided' }
                                : order
                        ),
                    };
                }
                case OrdersActionTypes.GET_ALL_ORDERS_REPORT: {
                    return { ...state, loadingOrdersReport: false, ordersReport: action.payload.data };
                }
                default:
                    return { ...state, loading: false, loadingOrdersReport: false };
            }

        //TODO: need error response for GET_ALL_ORDERS
        case OrdersActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case OrdersActionTypes.CREATE_LABEL_FOR_ORDER: {
                    return { ...state, creatingLabel: false, error: action.payload.error };
                }
                case OrdersActionTypes.REQUEST_ORDER_REFUND: {
                    return { ...state, cancellingOrder: false, error: action.payload.error };
                }
                case OrdersActionTypes.GET_ALL_ORDERS_REPORT: {
                    return { ...state, loadingOrdersReport: false, errorOrdersReport: action.payload.error };
                }
                default:
                    return { ...state, loading: false, loadingOrdersReport: false };
            }

        case OrdersActionTypes.GET_ALL_ORDERS:
            return { ...state, loading: true, orders: null };
        case OrdersActionTypes.GET_ALL_ORDERS_REPORT:
            return { ...state, loadingOrdersReport: true, ordersReport: null, errorOrdersReport: null };
        case OrdersActionTypes.CREATE_LABEL_FOR_ORDER:
            return { ...state, creatingLabel: true };
        case OrdersActionTypes.REQUEST_ORDER_REFUND:
            return { ...state, cancellingOrder: true };
        case OrdersActionTypes.RESET_STATE:
            return INIT_STATE;
        case OrdersActionTypes.RESET_ALL_ERRORS:
            return { ...state, error: null, errorOrdersReport: null };
        default:
            return { ...state };
    }
};

export default Orders;
